var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");
